// Incremental compile cache storage keyed by stable runtime source id.
// It keeps selector-block cache snapshots across rebuild cycles.
import type { LuisIncrementalCompileCache } from '@lentystyle/compiler/incremental';

const incrementalCompileCacheBySourceId = new Map<string, LuisIncrementalCompileCache>();

// Read incremental cache snapshot by source id.
export function getIncrementalCompileCache(sourceId?: string): LuisIncrementalCompileCache | undefined {
  // Return undefined when caller has no stable source id.
  if (!sourceId) {
    return undefined;
  } else {
    // Return cached snapshot for stable source id.
    return incrementalCompileCacheBySourceId.get(sourceId);
  }
}

// Save incremental cache snapshot for one source id.
export function setIncrementalCompileCache(sourceId: string, cache: LuisIncrementalCompileCache): void {
  incrementalCompileCacheBySourceId.set(sourceId, cache);
}

// Remove incremental cache entries that are no longer active in DOM sources.
export function pruneIncrementalCompileCache(activeSourceIds: string[]): void {
  const activeSet = new Set(activeSourceIds);
  // Drop cache entries for detached/removed source ids.
  for (const sourceId of Array.from(incrementalCompileCacheBySourceId.keys())) {
    if (!activeSet.has(sourceId)) {
      incrementalCompileCacheBySourceId.delete(sourceId);
    } else {
      // Keep cache entry for active source ids.
    }
  }
}
